<form [formGroup]="formGroup" #formDirective="ngForm" autocomplete="off">
  <div class="row">
    <div class="col-xl-6 col-12">
      <mat-form-field class="w-100">
        <mat-label>{{ 'Public.ContactData.Prename' | translate }}</mat-label>
        <input matInput formControlName="prename" autocomplete="new-password">
        @if (formGroup.get('prename')?.hasError('required')) {
          <mat-error>
            {{ 'Public.ContactData.Validation.Required' | translate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="col-xl-6 col-12">
      <mat-form-field class="w-100">
        <mat-label>{{ 'Public.ContactData.Name' | translate }}</mat-label>
        <input matInput formControlName="name" autocomplete="new-password">
        @if (formGroup.get('name')?.hasError('required')) {
          <mat-error>
            {{ 'Public.ContactData.Validation.Required' | translate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>

  @if (isDiplomat) {
    <div class="row">
      <div class="col-xl-6 col-12">
        <mat-form-field class="w-100">
          <mat-label>{{ 'Public.ContactData.Mail' | translate }}</mat-label>
          <input matInput formControlName="mail" autocomplete="new-password">
          @if (formGroup.get('mail')?.hasError('emailPattern')) {
            <mat-error>
              {{ 'Public.ContactData.Validation.EmailPattern' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  }

  @if (!isDiplomat) {
    <div class="row">
      <div class="col-xl-6 col-12 mb-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'Public.ContactData.Mobile' | translate }}</mat-label>
          <input matInput formControlName="mobile" autocomplete="new-password" placeholder="+41 79 123 45 67 / +41 58 123 45 67">
          <mat-hint>
            {{ 'Public.ContactData.Hint.PhonePattern' | translate }}
          </mat-hint>
          @if (formGroup.get('mobile')?.hasError('pattern')) {
            <mat-error>
              {{ 'Public.ContactData.Validation.PhonePattern' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-xl-6 col-12">
        <mat-form-field class="w-100">
          <mat-label>{{ 'Public.ContactData.Mail' | translate }}</mat-label>
          <input matInput formControlName="mail" autocomplete="new-password">
          @if (formGroup.get('mail')?.hasError('emailPattern')) {
            <mat-error>
              {{ 'Public.ContactData.Validation.EmailPattern' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  }

  @if (!isDiplomat) {
    <div class="row">
      @if (showCorrespondenceLanguage) {
        <div class="col-12" [ngClass]="showMailToggle ? 'col-xl-3' : 'col-xl-6'" >
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'Public.ContactData.CorrespondenceLanguage' | translate }}</mat-label>
            <mat-select panelClass="picker-options" formControlName="language">
              @for (language of languages; track language) {
                <mat-option [value]="language.languageCode">
                  {{ language.name }}
                </mat-option>
              }
            </mat-select>
            @if (formGroup.get('language')?.hasError('required')) {
              <mat-error>
                {{ 'Public.ContactData.Validation.Required' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
      @if (!showAdditionalMail && showMailToggle) {
        <div class="col-xl-3 col-12 pt-3">
          <mat-slide-toggle [formControl]="showMailToggleControl" (click)="mailToggleChange()">
            {{ 'Public.ContactData.SendTicketToBookingPerson' | translate}}
          </mat-slide-toggle>
        </div>
      }
      @if (showAdditionalMail) {
        <div class="col-xl-6 col-12">
          <mat-form-field class="w-100">
            <mat-label>{{ 'Public.ContactData.AdditionalMail' | translate }}</mat-label>
            <input matInput formControlName="additionalMail" autocomplete="new-password">
            @if (formGroup.get('additionalMail')?.hasError('emailPattern')) {
              <mat-error>
                {{ 'Public.ContactData.Validation.EmailPattern' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
    </div>
  }
</form>